import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  box-sizing: border-box;
  font-family: "Nunito Sans", sans-serif;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .left-side {
    display: flex;
    background: #f1f2f6;
    border-radius: 20px;
    padding: 3px;
    font-size: 15px;
    .toggle-btn {
      border-radius: 16px;
      cursor: pointer;
      border: none;
      background: transparent;
      color: #1f1f52;
      padding: 6px 10px;
      &.active {
        padding: 6px 16px;
        background: white;
        color: #1f1f52;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      }
    }
  }

  .right-side {
    display: flex;
    align-items: center;
    gap: 12px;

    .select-btn {
      display: flex;
      align-items: center;
    }

    .action-btn {
      display: flex;
    }

    .more-bnt {
      background: #f8f9fa;
      border: 1px solid #eaebed;
      border-radius: 50%;
      width: 35px;
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: #1f1f52;
    }
  }
`;

export const MainContent = styled.div`
  border-radius: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .content-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .content-wrapper-critico {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #f2f2f7;
    overflow: hidden;
  }
  .main-header {
    padding: 20px;
    position: relative;
    border-bottom: 1px solid #ffffff;
    .title {
      font-size: 25px;
      color: #1f1f52;
      font-family: "Nunito Sans Bold";
      margin-left: 15px;
    }

    .subtitle {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 17px;
      color: #4a5568;

      &::before {
        content: "";
        display: block;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #ff4d4f;
      }
    }

    .warning {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      color: #707582;
      margin-left: 15px;
      margin-top: 10px;
      &__icon {
        font-size: 13px;
        margin: auto 0;
        color: #3e3e5b;
      }
    }
  }

  .patient-list {
    flex: 1;
    overflow-y: auto;
    padding-top: 20px;
    .patient-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 20px;
      border-bottom: 1px solid #ffffff;
      cursor: pointer;
      &:last-child {
        border-bottom: none;
      }

      .patient-info {
        display: flex;
        align-items: center;
        gap: 16px;
        flex: 1.5;

        .avatar {
          width: 49px;
          height: 49px;
          border-radius: 50%;
          object-fit: cover;
          background: #ccc;
        }

        .name {
          font-size: 14px;
          color: #4a5568;
        }
      }

      .program-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        font-size: 14px;
        color: #3e3e5b;

        .program-info__label {
          font-size: 12px;
        }
      }

      .journey {
        flex: 1;
        display: flex;
        flex-direction: column;

        .phase {
          font-size: 14px;
          color: #3e3e5b;
        }

        .view-phase {
          font-size: 14px;
          color: #3e3e5b;
          cursor: pointer;
        }
      }

      .barrier-count {
        flex: 1;
        font-size: 14px;
        color: #000000;
      }

      .more-info-btn {
        display: flex;
        align-items: center;
        gap: 6px;
        background: #ffffff;
        border: 1px solid #eaebed;
        padding: 6px 14px;
        border-radius: 20px;
        font-size: 13px;
        color: #4a5568;
        cursor: pointer;

        i {
          color: #6c6bcc;
        }
      }
    }
  }

  .footer-bar {
    padding: 16px 0px;
    background: #fafafc;
    display: flex;
    align-items: center;
    gap: 16px;

    .status-bars {
      display: flex;
      flex: 1;
      gap: 20px;
      align-items: center;
      width: 100%;
      justify-content: space-evenly;
      background-color: #f2f2f7;
      border-radius: 20px;
      .status-pill {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 15px;
        color: #4a5568;
        font-family: "Nunito Sans";
        justify-content: center;
        cursor: pointer;
        padding: 8px 16px;
        border-radius: 20px;
        transition: all 0.3s ease;
        height: 34px;
        box-sizing: border-box;
        white-space: nowrap;
        &::after {
          content: "";
          display: block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }

        &.critico::after {
          background: #ff4d4f;
        }
        &.alto::after {
          background: #ffc107;
        }
        &.medio::after {
          background: #2196f3;
        }
        &.bajo::after {
          background: #00b11f;
        }

        &.active {
          flex: 1;
          color: white;
          padding: 8px 24px;
          background: #4a5568; /* Default fallback */

          &::after {
            background: white !important;
          }

          &.critico {
            background: #ff4d4f;
          }
          &.alto {
            background: #ffc107;
          }
          &.medio {
            background: #2196f3;
          }
          &.bajo {
            background: #00b11f;
          }
        }
      }
    }
  }
`;

export const ResueltasTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .table-header {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    padding: 20px 30px;
    border-bottom: 2px solid #eaebed;

    .th-item {
      font-size: 13px;
      color: #8c8c8c;
      font-weight: 500;
    }
    .th-actions {
      text-align: right;
    }
  }

  .table-body {
    flex: 1;
    overflow-y: auto;
    padding: 0 30px;

    .table-row {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
      align-items: center;
      padding: 16px 0;
      border-bottom: 1px solid #eaebed;

      .col-patient {
        display: flex;
        align-items: center;
        gap: 16px;

        .avatar {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          object-fit: cover;
          background: #ccc;
        }

        .info-group {
          display: flex;
          flex-direction: column;

          .phase {
            font-size: 12px;
            color: #8c8c8c;
          }
          .name {
            font-size: 15px;
            color: #1f1f52;
            font-weight: 700;
          }
          .barrier {
            font-size: 14px;
            color: #8c8c8c;
          }
        }
      }

      .col-date-rep {
        font-size: 14px;
        color: #8c8c8c;
      }

      .col-date-exp {
        font-size: 14px;
        color: #1f1f52;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 6px;

        .icon-date {
          font-size: 14px;
          &.delayed {
            color: #ff4d4f;
          }
          &.ontime {
            color: #1f1f52;
          }
        }
      }

      .col-date-res {
        font-size: 14px;
        color: #8c8c8c;
      }

      .col-actions {
        text-align: right;
        .ver-reporte {
          background: transparent;
          border: 1px solid #eaebed;
          color: #6c6bcc;
          border-radius: 20px;
          padding: 6px 14px;
          font-size: 13px;
          cursor: pointer;
        }
      }
    }
  }

  .eso-es-todo {
    text-align: center;
    padding: 20px;
    font-size: 15px;
    color: #4a5568;
  }
`;

export const RiskPopupContainer = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 24px;
  width: 320px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  font-family: inherit;

  .popup-risk-level {
    color: #ff4d4f;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .popup-score-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .score-texts {
      .points-main {
        font-size: 22px;
        color: #8c8c8c;
        font-weight: 300;
      }
      .points-sub {
        font-size: 16px;
        color: #a3a3a3;
        margin-top: 2px;
      }
    }

    .learn-more-btn {
      background: #f0f2ff;
      color: #2d39c4;
      border: none;
      border-radius: 15px;
      padding: 8px 16px;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      transition: background 0.2s;

      &:hover {
        background: #e5e8fe;
      }
    }
  }

  .popup-divider {
    height: 1px;
    background: #eaebee;
    margin: 18px 0;
    width: 100%;
  }

  .popup-desc {
    font-size: 14px;
    color: #404b69;
    line-height: 1.5;

    strong {
      font-weight: 600;
      color: #2e384d;
    }
  }
`;

export const ScoreExplanationPopup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: inherit;

  .tooltip-title {
    color: #8c52ff;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 8px;
    margin-left: 10px;
    display: flex;
    align-items: center;
    gap: 6px;

    .icon {
      font-size: 14px;
    }
  }

  .tooltip-white-box {
    background: #ffffff;
    border-radius: 20px;
    padding: 24px;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);

    h2 {
      font-size: 20px;
      color: #a3a3a3;
      margin: 0;
      font-weight: 300;
    }

    .divider {
      height: 1px;
      background: #eaebee;
      margin: 15px 0;
      width: 100%;
    }

    .scroll-content {
      max-height: 320px;
      overflow-y: auto;
      padding-right: 15px;
      font-size: 13px;
      color: #4a5568;
      line-height: 1.6;

      &::-webkit-scrollbar {
        width: 3px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: #a3a3a3;
        border-radius: 4px;
      }

      p {
        margin: 0 0 12px 0;
        &:last-child {
          margin: 0;
        }
      }
    }
  }
`;

export const ProgramSelector = styled.div`
  width: 297px;
  height: 225px;
  padding: 10px 10px 0px 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 12px 0px #23229d33;
  background-color: #fff;
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
    &__label {
      color: #707582;
    }
  }
  .list-programs {
    height: calc(100% - 29px);
    overflow: auto;
    .program-item {
      background-color: #f6f6ff;
      padding: 10px;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      margin-bottom: 10px;
      &--actived {
        background-color: #c6c5ff;
        font-family: Nunito Sans Bold;
      }
      &__name {
        font-size: 14px;
        color: #36369b;
      }
      &__quantity {
        display: flex;
        padding: 0px 10px;
        border-radius: 20px;
        background-color: #8a8ac3;
        align-items: center;
      }
      &__icon {
        font-size: 12px;
        color: #f6f6ff;
        margin-right: 5px;
      }
      &__number {
        font-size: 14px;
        color: #f6f6ff;
      }
    }
  }
`;

export const StatusSelector = styled.div`
  width: 297px;
  height: 350px;
  padding: 10px 10px 0px 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 12px 0px #23229d33;
  background-color: #eeeef7;
  .header {
    font-family: Nunito Sans Bold;
    font-size: 20px;
    padding: 10px 20px;
    color: #1f1f52;
    border-bottom: 2px solid #ffffff;
  }
  .list-groups {
    overflow: auto;
    display: flex;
    flex-direction: column;
    padding: 20px 10px 0px 10px;
    height: calc(100% - 69px);
    margin-bottom: 10px;
    &::-webkit-scrollbar {
      display: none;
    }
    .program-group {
      padding: 20px 10px 10px 10px;
      background-color: #ffffff;
      border-radius: 15px;
      margin-bottom: 10px;
      .group-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        &__text {
          color: #1f1f52;
          font-family: Nunito Sans Bold;
          font-size: 12px;
        }
        &__select {
          color: #2a28d6;
          font-family: Nunito Sans Bold;
          font-size: 12px;
          cursor: pointer;
        }
      }
      .group-stages-list {
        .group-stage {
          cursor: pointer;
          display: flex;
          align-items: center;
          padding: 18px 0;
          &__check {
            font-size: 20px;
            color: #2a28d6;
          }
          &__title {
            font-family: Nunito Sans;
            font-size: 18px;
            color: #1f1f52;
            margin-left: 5px;
          }
        }
      }
    }
  }
`;
